import React from 'react';
import { TextProps } from '@dreamai/types';

/**
 * Text component for our DSL
 */
const Text: React.FC<TextProps> = ({ size, value, ...props }) => {
  return size === 'small' ? (
    <small {...props}>{value}</small>
  ) : (
    <p {...props}>{value}</p>
  );
};

export default Text;
